import Vue from 'vue'

const vm = Vue.prototype

/**
 * 数据入口
 */
export const getDict = ({ commit }, catCode) => {
  return new Promise((resolve, reject) => {
    vm.$axios.post(vm.$URLS.dict, { cat_code: catCode })
      .then(({ data: { obj } }) => {
        if (!vm.$notNull(obj)) {
          resolve()
        }
        resolve(obj)
      })
  })
}



// WEBPACK FOOTER //
// ./src/store/common/actions.js